'use strict'

export default function FakeStreamFactory() {
    const DEFAULT_IMAGE = "http://localhost:3000/public/resource/image/src_resource_svg_Profile_empty_quit.svg";
    const canvas = document.createElement("canvas");
    const context = canvas.getContext('2d');

    let isDrawing = false;
    let drawLoopHandle = null;

    this.getFakeVideoTrack = (option = { videoType: 'black' }) => {
        const type = option.videoType || 'black';

        // Stop any previous drawing loop
        this.releaseFakeStream();

        let videoTrack;
        if (type === 'noise') {
            videoTrack = createWhiteNoiseVideoTrack();
        } else if (type === 'image') {
            videoTrack = createImageVideoTrack();
        } else {
            videoTrack = createBlackVideoTrack();
        }

        return videoTrack;
    };

    this.destroy = () => {
        this.releaseFakeStream();
        canvas.width = 0;
        canvas.height = 0;
    };

    this.releaseFakeStream = () => {
        isDrawing = false;

        if (drawLoopHandle !== null) {
            clearTimeout(drawLoopHandle);
            drawLoopHandle = null;
        }

        context.clearRect(0, 0, canvas.width, canvas.height);

        if (canvas.stream) {
            canvas.stream.getTracks().forEach(track => track.stop());
            canvas.stream = null;
        }
    };

    function createBlackVideoTrack(width = 1280, height = 720) {
        canvas.width = width;
        canvas.height = height;
        isDrawing = true;

        function draw() {
            if (!isDrawing) return;
            context.fillStyle = "#000";
            context.fillRect(0, 0, width, height);
            drawLoopHandle = setTimeout(draw, 33);
        }
        draw();

        const stream = canvas.captureStream(25);
        canvas.stream = stream;
        return stream.getVideoTracks()[0];
    }

    function createWhiteNoiseVideoTrack(width = 160, height = 120) {
        canvas.width = width;
        canvas.height = height;
        isDrawing = true;

        const p = context.getImageData(0, 0, width, height);

        function draw() {
            if (!isDrawing) return;
            for (let i = 0; i < p.data.length; i += 4) {
                const value = Math.random() * 255;
                p.data[i] = p.data[i + 1] = p.data[i + 2] = value;
                p.data[i + 3] = 255;
            }
            context.putImageData(p, 0, 0);
            drawLoopHandle = setTimeout(draw, 33);
        }
        draw();

        const stream = canvas.captureStream(25);
        canvas.stream = stream;
        return stream.getVideoTracks()[0];
    }

    function createImageVideoTrack(width = 640, height = 480) {
        canvas.width = width;
        canvas.height = height;
        isDrawing = true;

        const image = new Image();
        image.src = DEFAULT_IMAGE;

        image.onload = () => {
            function draw() {
                if (!isDrawing) return;
                context.drawImage(image, 0, 0, width, height);
                drawLoopHandle = setTimeout(draw, 33);
            }
            draw();
        };

        const stream = canvas.captureStream(25);
        canvas.stream = stream;
        return stream.getVideoTracks()[0];
    }
}